import { useCallback, useEffect } from "react"
import { fastTrackService } from "../../data/services/fastTrackService"
import { useApiStatus } from "../../common/hooks/useApiStatus"

export const useGenerateStagePreInscription = ({
    isLoading,
    apiRequest,
    email,
    setCheckoutSession,
}) => {
    const generate = useCallback(() => {
        apiRequest(fastTrackService.createStagePreInscription, {}, { email })
    }, [email])

    useApiStatus(
        fastTrackService.createStagePreInscription,
        null,
        true,
        (data) => setCheckoutSession(data)
    )

    useEffect(() => {
        if (isLoading) return
        generate()
    }, [generate, isLoading])
}
